import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import {onReactionError} from 'mobx';

import {MOBILE_MAX_SCREEN_SIZE} from 'base/search.js';
import autobind from 'common/decorators/autobind.js';
import {TRUE_STR} from 'core/constants.js';

import FocusManager from 'core/components/FocusManager.js';
import {DirectoryStoreContextV2} from 'core/stores/RootStore.js';
import BannerAdsListV2 from 'directory/v2/components/BannerAdsListV2.js';
import HealthFundDisclaimerV2 from 'directory/v2/components/HealthFundDisclaimerV2.js';
import DirectoryHeaderV2 from 'directory/v2/components/DirectoryHeaderV2.js';
import HealthFundInfoV2 from 'directory/v2/components/HealthFundInfoV2.js';
import SearchResultsV2 from 'directory/v2/components/SearchResultsV2.js';
import events from 'events.js';
import {captureException} from 'capture_sentry_exception.js';
import {snakeToCamelObjectKeys} from 'utils/case_converter.js';

require('intersection-observer');

export default class DirectoryAppV2 extends React.Component {
    static contextType = DirectoryStoreContextV2;

    static propTypes = {
        adData: PropTypes.object,
        interest: PropTypes.object,
        locality: PropTypes.object,
        promotedGapSchemes: PropTypes.arrayOf(
            PropTypes.shape({
                healthFundId: PropTypes.number,
                gapSchemeId: PropTypes.number,
            }),
        ),
        specialty: PropTypes.object.isRequired,
        telehealthDirectory: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        onReactionError(captureException);
        this.mobileMediaQuery = window.matchMedia(
            `screen and (max-width: ${MOBILE_MAX_SCREEN_SIZE})`,
        );
    }

    componentDidMount() {
        const {
            adData,
            locality,
            promotedGapSchemes,
            specialty,
            interest,
            state,
            telehealthDirectory,
        } = this.props;
        this.context.updateStore({
            locality,
            specialty,
            interest,
            adData,
            state,
            telehealthDirectory,
        });
        this.context.rootStore.healthFundStore.updateStore({
            promotedGapSchemes,
        });
        this.context.rootStore.setupLogrocket();
        this.onWindowResize();
        events.listen(window, ['resize', 'orientationchange'], () => {
            this.onWindowResize();
        });
    }

    componentWillUnmount() {
        events.unlisten(window, ['resize', 'orientationchange'], () => {
            this.onWindowResize();
        });
    }

    @autobind
    onWindowResize(event) {
        this.context.updateStore({
            isMobile: window.matchMedia(
                `(max-width: ${MOBILE_MAX_SCREEN_SIZE})`,
            ).matches,
        });
    }

    render() {
        return (
            <>
                <FocusManager />
                <DirectoryHeaderV2
                    telehealthDirectory={this.props?.telehealthDirectory}
                    offersTelehealth={this.props?.specialty?.offersTelehealth}
                />
                <div className="result-list">
                    <HealthFundInfoV2 />
                    <HealthFundDisclaimerV2 main={true} />
                    <BannerAdsListV2 forHealthFund={true} />
                    <HealthFundDisclaimerV2 />
                    <BannerAdsListV2 />
                    <SearchResultsV2 />
                </div>
            </>
        );
    }
}

(async function () {
    await events.ready();

    const directorySection = document.querySelector('#directory');
    const props = snakeToCamelObjectKeys(
        JSON.parse(directorySection.dataset.directory),
    );
    ReactDOM.render(<DirectoryAppV2 {...props} />, directorySection);
})();
